<template>
  <bpb-form-communicator v-model="internalValue" :name="name">
    <div class="input-newsletter__input input-newsletter-text">
      <label
        v-if="!!$slots.label || label"
        :class="{ 'a-visually-hidden': labelHidden }"
        :for="id"
        class="input-newsletter-text__label"
      >
        <!-- <strong v-if="hasError"><a-label path="error.name">:</a-label></strong> -->
        <slot name="label" />{{ label }}{{ required ? ' *' : '' }}
      </label>
      <input
        :id="id"
        ref="input"
        v-focus-on-page-load="{ active: focusOnPageLoad }"
        :placeholder="placeholder"
        :value="internalValue"
        :name="name"
        type="text"
        :required="required"
        :aria-required="required"
        :disabled="disabled"
        :aria-disabled="disabled"
        class="input-newsletter-text__input"
        v-bind="
          $makeFieldUpdateBinding({
            classListObject: {
              'input-newsletter-text__input--is-disabled': disabled,
            },
          })
        "
        @change="change"
        @enter="onEnter"
      />
      <bpb-form-error-portal :name="name" />
    </div>
  </bpb-form-communicator>
</template>

<script>
import {
  InputIdProvider,
  FieldUpdateProvider,
} from '@components/molecules/form/form.mixin.js';

export default {
  mixins: [
    InputIdProvider,
    FieldUpdateProvider({ baseClass: 'input-newsletter-text__input' }),
  ],
  inject: {
    submit: {
      default() {
        return () => {
          // fail silently, if not inside form
        };
      },
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    labelHidden: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    focusOnPageLoad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  methods: {
    change(event) {
      const value = event.target.value;
      this.internalValue = value;
      this.$emit('change', value);
    },
    onEnter() {
      const value = this.$refs.input.value;
      this.internalValue = value;
      this.$emit('change', value);
      this.submit();
    },
  },
};
</script>
